module.exports = __webpack_public_path__ + "img/no_user.a3b1bc30.png";